<script setup>
import {useStore} from "vuex";
import {ref, onMounted, computed} from "vue";
import axios from "axios";
//import {useScrollBottom} from "@/use/scroll-bottom";
// не используется, теперь api 080125
//import {criteriaList} from "@/use/criteria-list";

//----------------------------------------------------------------------

const store = useStore()
const isSubmitting = ref(false)
const isSubmitComplete = ref(false)
const infoMessage = ref('')

// поправка, если оценки начинаются с 0
const changeIndex = ref(0)
// все критерии отмечены и готовы к отправке
const isCriteriaReady = ref(false)
// критерии для отображения на странице (пустые:criteriaList или заполненные:savedCriteria)
const criteria = ref([])
// полученные данные о сохраненных критериях
const savedCriteria = ref([])
// первоначальная оценка
const firstAction = ref(true)
// если id задачи передается в параметре, то на сервере это валидируется на предмет наличия отдельного файла с критериями
const taskError = ref(false)
const token = computed( () => {return store.getters['authModule/token']})

//----------------------------------------------------------------------

// eslint-disable-next-line no-undef
const props = defineProps({
  teamId:{
    type: String,
    required: true,
  },
  userId:{
    type: String,
    required: true,
  },
  taskId:{
    type: String,
    required: true,
  },
})

//----------------------------------------------------------------------
onMounted( ()=>{
  try {
    init()
  } catch (err) {
    alert ('APPLICATION ERROR')
  }
})
//----------------------------------------------------------------------

const init = async () => {

  // оценки начинаются с 0 или 1

  if (+process.env.VUE_APP_RATING_START === 0){
    // поправка, если оценки начинаются с 0
    changeIndex.value = 1
  }

  // сохраненные оценки отдельной команды от члена жюри
  const url = process.env.VUE_APP_ADMIN_URL + "/api/criteria.php"
  await axios
      .get(`${url}?userId=${props.userId}&teamId=${props.teamId}&token=${token.value}`)
      .then(response => (savedCriteria.value = response.data))
      .catch(error => alert(error));

  if (savedCriteria.value.length > 0){

    // оценки уже есть

    firstAction.value = false
    criteria.value = savedCriteria.value;
    infoMessage.value="Для отправки результатов измените значение выбранного критерия";

  } else {

    // критерии без оценок
    // criteriaList_ + ID задачи, если каждая задача имеет свои критерии
    // если критерии общие, то criteriaList.php

    let urlCriteriaList = ""
    if (process.env.VUE_APP_CRITERIAS_TYPE === 0){
      //общие критерии для всех задач
      //вся информация должна содержаться в criteriaList.php
      urlCriteriaList = process.env.VUE_APP_ADMIN_URL + "/api/data/criteriaList.php"
    } else {

      console.log(props.taskId)
      //отдельные критерии для каждой задачи
      urlCriteriaList = process.env.VUE_APP_ADMIN_URL + "/api/data/criteriaList.php?taskId=" + props.taskId
    }

    await axios
        .get(`${urlCriteriaList}`)
        .then(response => (criteria.value = response.data))
        .catch(error => criteriaError(error));

    if (criteria.value.error === 'NOT_FOUND'){
      taskError.value = true
    }

    firstAction.value = true
    infoMessage.value="Для отправки результатов укажите значения всех критериев";
  }

}

const criteriaError = () => {
  console.log('error')
}

//----------------------------------------------------------------------

const setCriteria = (value, index, sectionIndex, changeIndex) => {
    isCriteriaReady.value = true

    criteria.value[index]['sections'][sectionIndex]['activeIndex'] = value - changeIndex;
    // если какой то критерий не отмечен, отправить данные нельзя
    criteria.value.forEach(function (item) {
      item['sections'].forEach(function (section) {

        if (section['activeIndex'] === ( 0 - changeIndex )) {
          isCriteriaReady.value = false
        }

      })
    });

}

//----------------------------------------------------------------------

// добавление комментария к разделу
const criteriaReady = () => {
  if (!firstAction.value && !isCriteriaReady.value) {
    isCriteriaReady.value = true
  }
}

// если например надо показать только 0, 5, 15
/*
const checkValue = (val) => {
  val--
  return val % 5 === 0
}
 */


//----------------------------------------------------------------------

const onSubmit = async () => {

  try {
    isSubmitting.value = true

    const headers = {
      'Authorization': 'Bearer ' + token.value
    }

    const values = {
      'criteria' : criteria.value,
      'teamId' : props.teamId,
      'userId': props.userId,
    }

    //const payload = {values, ...{'userId': user.value.id}}
    //console.log(values)
    const authSendResults = process.env.VUE_APP_ADMIN_URL + '/api/save.php'
    const {data} = await axios.post(authSendResults, values, {
      headers: headers
    })

    //console.log(data)

    if (data['status'] === 'SUCCESS'){
      isSubmitComplete.value = true;
      isSubmitting.value = false;
      isCriteriaReady.value = false;
      //setTimeout(() => useScrollBottom(), 300);
      setTimeout(() => isSubmitComplete.value = false, 3000);
    }

  } catch (e) {
    alert ('INTERNAL_SERVER_ERROR')
  }

}
</script>
<template>
  <div v-if="!taskError">
    <h3 class="text-center">Критерии оценки</h3>

    <div class="number mt-4">1</div>
    <div class="v-line"></div>

    <div
        v-for="(item,index) in criteria"
        :key="index"
    >
      <div
          class="card card-outline card-info m-0"
      >
        <div class="card-header"><h4 class="text-center">{{ item['title'] }}</h4></div>
        <div class="card-body pb-5">
          <div
              v-for="(section,sectionIndex) in item['sections']"
              :key="sectionIndex"
          >
            <div :class="['m-auto w-75', {'border-bottom': item['sections'].length > 1 }]">
              <div class="m-4 text-center" v-html="section['name']"></div>
              <div class="d-flex flex-wrap justify-content-center">

                <div
                    v-for="value in (section['values'] + changeIndex)" :key="value"
                >

                  <div
                      :class="['criteria-counter m-3', {'criteria-counter-selected': section['activeIndex'] === (value-changeIndex) }]"
                      @click="setCriteria(value, index, sectionIndex, changeIndex)"
                  >
                    {{ value-changeIndex }}
                  </div>

                </div>


              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="m-auto w-75 p-3">
            <div class="p-1">Комментарий к оценке раздела</div>
            <textarea
                class="form-control"
                rows="2"
                v-model="item['comment']"
                @keydown="criteriaReady()"
            ></textarea>
          </div>
        </div>

      </div>
      <div v-if="index < (criteria.length-1)">
        <div class="v-line"></div>
        <div class="number">{{ index+2 }}</div>
        <div class="v-line"></div>
      </div>
    </div>

    <div class="text-center mt-5 mb-4">

      <div v-if="isSubmitComplete"  class="alert alert-success text-center">
        <v-icon
            class="success-icon--white m-2"
            icon="mdi:check-circle-outline"
        ></v-icon>
        <h4>Оценки отправлены</h4>
      </div>

      <button
          class="btn btn-send"
          @click="onSubmit()"
          :disabled="!isCriteriaReady"
      >
        <svg v-if="isSubmitting && !isSubmitComplete"
             xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g>
          <circle cx="3" cy="12" r="2" fill="#fff"/>
          <circle cx="21" cy="12" r="2" fill="#fff"/>
          <circle cx="12" cy="21" r="2" fill="#fff"/>
          <circle cx="12" cy="3" r="2" fill="#fff"/>
          <circle cx="5.64" cy="5.64" r="2" fill="#fff"/>
          <circle cx="18.36" cy="18.36" r="2" fill="#fff"/>
          <circle cx="5.64" cy="18.36" r="2" fill="#fff"/>
          <circle cx="18.36" cy="5.64" r="2" fill="#fff"/>
          <animateTransform attributeName="transform" dur="1.5s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"/></g>
        </svg>
        <span v-else>Отправить оценки</span>
      </button>

      <div v-if="!isCriteriaReady" class="m-2 text-danger text-bold">
        {{ infoMessage }}
      </div>
    </div>

  </div>
  <div v-else>
    <div class="alert alert-danger alert-dismissible">
      <h5>Что-то пошло не так...</h5>
      Список критериев для оценки данной данной команды не найден
    </div>
  </div>
</template>
<style scoped>
.criteria-counter{
  background-color:#eff3f9;
  padding:10px 10px;
  margin:10px;
  font-size:21px;
  font-weight:bold;
  text-align:center;
  cursor:pointer;
  border-radius: 50px;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  width:52px;
  transition: 0.3s;
}

.criteria-counter:hover{
  background-color:#bdd8e8 !important;
}

.criteria-counter-selected{
  background-color:#80b5d3 !important;
  color:#fff;
}
</style>